import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

export const styles: StyleRulesCallback = ({ breakpoints, spacing: { unit } }) => ({
  container: {
    margin: `0 auto ${unit}px`,
    maxWidth: unit * 190,
    padding: `0 ${unit * 2}px`,
    width: "100%",
    [breakpoints.up("lg")]: {
      padding: `0 ${unit * 3}px`
    }
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
